import { useFirebase } from '~/shared/lib/firebase'

// This plugin only runs on client-side
export default defineNuxtPlugin((nuxtApp) => {
  // Initialize Firebase when the app mounts
  nuxtApp.hook('app:mounted', () => {
    const { initializeFirebase } = useFirebase()
    initializeFirebase()
  })
})
